export default ( state: any = [], action: any ) => {
  switch ( action.type ) {
  case "SET_BILLING_ORDERS":
    return action.billingOrders
  case "ADD_BILLING_ORDER":
    return [
      ...state,
      action.billingOrder,
    ]
  case "UPDATE_BILLING_ORDER":
    return [
      ...state.filter( bo => bo.id !== action.billingOrder.id ),
      {
        ...state.find( bo => bo.id === action.billingOrder.id ),
        ...action.billingOrder,
      },
    ]
  case "DELETE_BILLING_ORDER":
    return state.filter( bo => bo.id !== action.id );
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/billingOrders.jsx